import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const configApi: any = createApi({
  reducerPath: "configApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "./",
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "POST, GET",
      "Access-Control-Allow-Origin": "*",
    },
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    config: builder.query({
      query: () => {
        return {
          url: `config/config.json`,
          method: "GET",
        };
      },
    }),
  }),
});
export const { useConfigQuery } = configApi;
